package haxe.ui.util.filters;

class Blur extends Filter {
    public var amount:Float;

    public function new() {
        super();
    }
}